<ng-container *ngIf="page_summary_data_loaded">

    <div class="new-summary-section">
        <div class="each-new-summary-section">
            <p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.source_data) }}</p>
            <p class="each-new-summary-section-label">Source Data</p>
        </div>
        <div class="each-new-summary-section">
            <p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
            <p class="each-new-summary-section-label">Leads</p>
        </div>
        <div class="each-new-summary-section">
            <p class="each-new-summary-section-count" *ngIf="user_details.role.business_area[0] == 6">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
            <p class="each-new-summary-section-count" *ngIf="user_details.role.business_area[0] != 6">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{page_summary_data.total_opportunity }}</p>
            <p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
        </div>
        <div class="each-new-summary-section">
            <div class="each-new-summary-section-switch">
                <mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
            </div>
            <p class="each-new-summary-section-label">Graphical Representation</p>
        </div>
        <div class="each-new-summary-section">
            <div class="each-new-summary-section-switch">
                <mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_source_data" (change)="toggleSourceData()" ></mat-slide-toggle>
            </div>
            <p class="each-new-summary-section-label">View Source Data</p>
        </div>
        <div class="each-new-summary-section">
            <div class="each-new-summary-section-switch">
                <mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" (change)="toggleAnalysis()" ></mat-slide-toggle>
            </div>
            <p class="each-new-summary-section-label">View Analysis</p>
        </div>
    </div>

    <div class="page-graphs-section" [hidden]="!show_graphical_representation">

        <!-- <div class="each-summary-graph-block large-graph" *ngIf="type == 'Institutional Customers to Deposit Clients'"> -->
        <div class="each-summary-graph-block large-graph">
            <div class="summary-graph-heading-section">
                <img src="assets/events.png" class="summary-graph-heading-icon" />
                <span>Leads by Branches</span>
            </div>
            <div class="each-summary-graph-content">
                <div id="branches-graph"></div>
            </div>
        </div>

        <ng-container *ngIf="user_details.role.business_area[0] == 8">
          <div class="each-summary-graph-block">
              <div class="summary-graph-heading-section">
                  <img src="assets/events.png" class="summary-graph-heading-icon" />
                  <span>Opportunities by Loan Type</span>
              </div>
              <div class="each-summary-graph-content">
                  <div id="opp-loan-type-graph"></div>
              </div>
          </div>

          <div class="each-summary-graph-block">
              <div class="summary-graph-heading-section">
                  <img src="assets/events.png" class="summary-graph-heading-icon" />
                  <span>Cross-Sell Opportunities by Product</span>
              </div>
              <div class="each-summary-graph-content">
                  <div id="cross-sell-product-graph"></div>
              </div>
          </div>

          <div class="each-summary-graph-block">
              <div class="summary-graph-heading-section">
                  <img src="assets/events.png" class="summary-graph-heading-icon" />
                  <span>Loan Type–Product Mapping</span>
              </div>
              <div class="each-summary-graph-content">
                  <div id="product-mapping-graph"></div>
              </div>
          </div>
        </ng-container>




        <div class="each-summary-graph-block">
            <div class="summary-graph-heading-section">
                <img src="assets/events.png" class="summary-graph-heading-icon" />
                <span *ngIf="type == 'Institutional Customers to Deposit Clients'">Leads Across Various Financial Products</span>
                <span *ngIf="type != 'Institutional Customers to Deposit Clients'">Leads by Third Party Sources</span>
            </div>
            <div class="each-summary-graph-content">
                <div id="source-comparision-graph"></div>
            </div>
        </div>

        <div class="each-summary-graph-block">
            <div class="summary-graph-heading-section" style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
                <div>
                    <img src="assets/events.png" class="summary-graph-heading-icon" />
                    <span>Leads by Duration</span>
                </div>
                <div>
                    <mat-select class="summary-graph-input" [(ngModel)]="leads_duration_filter"  (selectionChange)="durationGraphChange()">
                        <mat-option [value]="'Monthly'">Monthly</mat-option>
                        <mat-option [value]="'Quarterly'">Quarterly</mat-option>
                        <mat-option [value]="'Yearly'">Yearly</mat-option>
                    </mat-select>
                </div>
            </div>
            <div class="each-summary-graph-content">
                <ng-container *ngIf="duration_grapH_loaded">
                    <div id="leads-duration-graph"></div>
                </ng-container>
            </div>
        </div>

        <div class="each-summary-graph-block">
            <div class="summary-graph-heading-section">
                <img src="assets/events.png" class="summary-graph-heading-icon" />
                <span>Leads by Demographic Segments</span>
            </div>
            <div class="each-summary-graph-content">
                <div id="demographic-segments-graph"></div>
            </div>
        </div>

        <div class="each-summary-graph-block">
            <div class="summary-graph-heading-section">
                <img src="assets/events.png" class="summary-graph-heading-icon" />
                <span>Leads by Income Range</span>
            </div>
            <div class="each-summary-graph-content">
                <div id="income-range-graph"></div>
            </div>
        </div>

        <!-- <div class="each-summary-graph-block">
            <div class="summary-graph-heading-section">
                <img src="assets/events.png" class="summary-graph-heading-icon" />
                <span>Leads By Region</span>
            </div>
            <div class="each-summary-graph-content">
                <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions" [(update)]="updateFlag" [oneToOne]="true" style="width: 100%; height: 310px; display: block"></highcharts-chart>
            </div>
        </div> -->

    </div>

    <div *ngIf="show_source_data">
        <div class="summary-table-data-section">
            <div class="summary-table-section">
                <div>
                    <div class="new-table-v2-overflow">
                        <div class="new-table-heading-section">
                            <span>AI Explainability</span>
                            <div class="section-heading-tooltip-block">
                                <img src="assets/info-black.png" />
                                <div class="section-heading-tooltip-section">
                                  <div class="module-page-information-section" *ngFor="let section of ai_explainability_sections">
                                    <div class="each-module-page-information-section">
                                      <p class="each-module-page-information-heading">{{section.name}}</p>
                                    </div>
                                    <ng-container *ngIf="section.sub_sections">
                                      <ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
                                        <div class="each-module-page-information-sub-section">
                                          <p class="each-module-page-information-sub-heading">{{index + 1}}. {{sub_section.name}}:</p>
                                          <p class="each-module-page-information-sub-content">{{sub_section.value}}</p>

                                          <ng-container *ngIf="sub_section.sub_sections">
                                            <div class="each-module-page-information-sub-section" *ngFor="let sub_section of sub_section.sub_sections; let index = index">
                                              <p class="each-module-page-information-sub-heading">{{index + 1}}) {{sub_section.name}}:</p>
                                              <p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
                                            </div>
                                          </ng-container>

                                        </div>
                                      </ng-container>
                                    </ng-container>
                                  </div>
                                </div>
                              </div>
                            <div class="new-table-actions ml-4">
                                <div class="each-action-section search-input-section" *ngIf="show_search">
                                    <input type="text" placeholder="Search" class="search-input" [(ngModel)]="search_key" (input)="current_pagination_page = 1; getTableData()" />
                                    <span class="search-input-close" (click)=" show_search = false; search_key = '';current_pagination_page = 1; getTableData()">&times;</span >
                                </div>
                                <div class="each-action-section search-icon" *ngIf="!show_search" (click)="show_search = true">
                                    <img src="assets/search.png" class="button-icon" />
                                    <span>Search</span>
                                </div>
                                <div class="each-action-section dynamic-columns-section">
                                    <img src="assets/column-filter.png" class="button-icon" (click)="show_toggle_columns = !show_toggle_columns" />
                                    <div class="dynamic-columns" *ngIf="show_toggle_columns">
                                        <div class="dynamic-column-heading-section">
                                            <span>Filter Columns</span>
                                            <span class="columns-close" (click)="show_toggle_columns = false" >&times;</span>
                                        </div>
                                        <div class="dynamic-column-content">
                                            <div class="each-column-section" *ngFor="let column of table_columns">
                                                <mat-checkbox [checked]="column.checked == true" (change)="column.checked = !column.checked" >{{ column.name }}</mat-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="alphabets-filter-section">
                                <p class="new-each-filter-alphabet" [ngClass]="{ 'new-filter-alphabet-selected': alphabet == selected_alphabet }" *ngFor="let alphabet of alphabets_array" (click)=" current_pagination_page = 1; selected_alphabet = alphabet; getTableData() " style="margin-bottom: 8px !important"> {{ alphabet }}</p>
                                <p class="clear-filter-alphabet" (click)=" current_pagination_page = 1; selected_alphabet = ''; getTableData() " > Clear</p>
                            </div>
                            <div class="new-table-v2-overflow">
                                <table class="new-table-v2">
                                    <thead>
                                        <tr>

                                            <th appColumnResizable>
                                                Actions
                                            </th>

                                            <ng-container *ngIf="type == 'Upside Opportunities' && stepper_stage.position == 'last'">
                                                <th appColumnResizable>Outcome Status</th>
                                                  <th appColumnResizable>Outcome Comments</th>
                                            </ng-container>

                                            <ng-container *ngIf="type == 'Retention Opportunities' && stepper_stage.position == 'last'">
                                                <th appColumnResizable>Outcome Status</th>
                                                  <th appColumnResizable>Outcome Comments</th>
                                            </ng-container>

                                            <!-- <ng-container *ngIf="type == 'Institutional Customers to Investment Clients' && stepper_stage.position == 'last'"> -->
                                            <ng-container *ngIf="type == 'Bank Customers to Investment Clients' && stepper_stage.position == 'last'">
                                                <th appColumnResizable>Outcome Status</th>
                                                  <th appColumnResizable>Outcome Comments</th>
                                            </ng-container>

                                            <!-- <ng-container *ngIf="type == 'Institutional Customers to Deposit Clients' && stepper_stage.position == 'last'"> -->
                                            <ng-container *ngIf="type == 'Bank Customers to Deposit Clients' && stepper_stage.position == 'last'">
                                                <th appColumnResizable>Outcome Status</th>
                                                  <th appColumnResizable>Outcome Comments</th>
                                            </ng-container>

                                            <!-- <ng-container *ngFor="let column of table_columns">
                                                <th appColumnResizable *ngIf="column.checked">{{ column.name }}</th>
                                            </ng-container> -->

                                            <ng-container *ngFor="let column of table_columns" [ngSwitch]="column.key">
                                                <ng-container *ngSwitchCase="'trigger'">
                                                    <th appColumnResizable *ngIf="column.checked" style="width: 350px;">{{ column.name }}</th>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'trigger_condition'">
                                                    <th appColumnResizable *ngIf="column.checked" style="width: 500px;">{{ column.name }}</th>
                                                </ng-container>
                                                <ng-container *ngSwitchDefault>
                                                    <th appColumnResizable *ngIf="column.checked">{{ column.name }}</th>
                                                </ng-container>
                                            </ng-container>
                                        </tr>
                                    </thead>
                                    <ng-container *ngIf="table_data_loaded">
                                        <tbody *ngIf="table_data.length > 0">
                                            <ng-container *ngFor="let client of table_data | paginate : { id: 'source-table-data', itemsPerPage: pagination_records_limit, currentPage: current_pagination_page, totalItems: total_pagination_records }; let clientIndex = index">
                                                <tr>
                                                    <td>
                                                        <!-- <img src="assets/view-tasks.png" class="client-table-icon" (click)="openClientDataModal(client)" /> -->
                                                        <img src="assets/view-tasks.png" class="client-table-icon" (click)="showUserProfile(client)" />
                                                        <img src="assets/exclamation-icon.png" class="client-table-icon" *ngIf="client.trigger_status == 'Inactive'" [matTooltip]="client.trigger_description" />
                                                    </td>

                                                    <ng-container *ngIf="type == 'Upside Opportunities' && stepper_stage.position == 'last'">
                                                        <td>
                                                            <span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
                                                        </td>
                                                        <td>{{ client.conversion_comments }}</td>
                                                    </ng-container>

                                                    <ng-container *ngIf="type == 'Retention Opportunities' && stepper_stage.position == 'last'">
                                                        <td>
                                                            <span [ngClass]="{'new-leads-activity-status': client.attrition_status == 'Retained', 'activity-status-completed': client.attrition_status == 'Retained, Upside', 'activity-status-pending': client.attrition_status == 'Likely to Switch Advisor'}">{{ client.attrition_status }}</span>
                                                        </td>
                                                        <td>{{ client.attrition_comments }}</td>
                                                    </ng-container>

                                                    <!-- <ng-container *ngIf="type == 'Institutional Customers to Investment Clients' && stepper_stage.position == 'last'"> -->
                                                    <ng-container *ngIf="type == 'Bank Customers to Investment Clients' && stepper_stage.position == 'last'">
                                                        <td>
                                                            <span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
                                                        </td>
                                                        <td>{{ client.conversion_comments }}</td>
                                                    </ng-container>

                                                    <!-- <ng-container *ngIf="type == 'Institutional Customers to Deposit Clients' && stepper_stage.position == 'last'"> -->
                                                    <ng-container *ngIf="type == 'Bank Customers to Deposit Clients' && stepper_stage.position == 'last'">
                                                        <td>
                                                            <span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
                                                        </td>
                                                        <td>{{ client.conversion_comments }}</td>
                                                    </ng-container>

                                                    <ng-container *ngFor="let column of table_columns" [ngSwitch]="column.key">
                                                        <ng-container *ngSwitchCase="'advisor_status'">
                                                            <td *ngIf="column.checked">
                                                                <p class="status-tag completed-status">
                                                                    {{ client.advisor_status }}
                                                                </p>
                                                            </td>
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'ai_rank'">
                                                            <td class="highlight-table-cell" *ngIf="column.checked">
                                                                {{ getKey(client, column) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'opportunity'">
                                                            <td class="highlight-table-cell" *ngIf="column.checked">
                                                                {{ getKey(client, column) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'total_estimated_loss'">
                                                            <td class="highlight-table-cell" *ngIf="column.checked">
                                                                {{ getKey(client, column) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'predicted_wallet_share_growth'">
                                                            <td class="highlight-table-cell" *ngIf="column.checked">
                                                                {{ getKey(client, column) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'predicted_closure_days'">
                                                            <td class="highlight-table-cell" *ngIf="column.checked">
                                                                {{ getKey(client, column) }} Day(s)
                                                            </td>
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'recommended_products'">
                                                            <td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getKey(client, column)">
                                                                {{ getKey(client, column) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'preferred_channel'">
                                                            <td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getKey(client, column)">
                                                                {{ getKey(client, column) }}
                                                            </td>
                                                        </ng-container>

                                                        <ng-container *ngSwitchCase="'trigger'">
                                                            <td *ngIf="column.checked">
                                                              <span [style.color]="client['trigger_type'] == 'AI' ? '#f3a638' : '#4cb64c'">{{ getKey(client, column) }}</span>
                                                            </td>
                                                          </ng-container>

                                                        <ng-container *ngSwitchDefault>
                                                            <td *ngIf="column.checked">
                                                                {{ getKey(client, column) }}
                                                            </td>
                                                        </ng-container>
                                                    </ng-container>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                        <tbody *ngIf="table_data.length == 0">
                                            <td colspan="15">
                                                <div class="new-table-v2-zero-section">
                                                    <!-- <img src="assets/no-data-table.png" /> -->
                                                    <p class="new-table-v2-zero-label">No Data Found</p>
                                                </div>
                                            </td>
                                        </tbody>
                                    </ng-container>
                                    <ng-container *ngIf="!table_data_loaded">
                                        <tbody>
                                            <tr>
                                                <td colspan="15">
                                                    <app-loader [loading_text]="'Loading Data'"></app-loader>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </ng-container>
                                </table>
                            </div>
                            <div class="new-table-v2-pagination-section">
                                <span class="mr-4">{{ total_pagination_records | number:'1.0-0' }} Records</span>
                                <mat-select class="pagination-input" [(ngModel)]="pagination_records_limit" (selectionChange)="current_pagination_page = 1; getTableData()">
                                    <mat-option [value]="10">10</mat-option>
                                    <mat-option [value]="100">100</mat-option>
                                    <mat-option [value]="500">500</mat-option>
                                    <mat-option [value]="1000">1000</mat-option>
                                </mat-select>
                                <div class="new-table-v2-pagination-controls">
                                    <pagination-controls id="source-table-data" (pageChange)="pageChanged($event)" style="text-align: right; position: relative; top: 6px" ></pagination-controls>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="show_analysis">
        <!-- <app-opp-analysis [type]="type + ' Analysis'" [show_navigation]="false" [show_header]="false" [selected_opportunity_period]="selected_opportunity_period"></app-opp-analysis> -->
        <app-opp-analysis-v2 [type]="type + ' Analysis'" [show_navigation]="false" [show_header]="false" [selected_opportunity_period]="selected_opportunity_period"></app-opp-analysis-v2>
    </div>


</ng-container>

<ng-container *ngIf="!page_summary_data_loaded">
	<app-loader [loading_text]="'Loading Data'"></app-loader>
</ng-container>


<ng-template #clientDataModal>
    <div class="modal-section client-details-modal">
        <div class="modal-heading-section client-view-heading-section">
            <span class="modal-heading">Know Your Lead</span>
            <span class="client-modal-icon" (click)="closeClientDataModal()">&times;</span>
        </div>
        <div class="modal-content-section" *ngIf="!selected_modal_client_loader">
            <app-prospect-profile [prospect_data]="selected_modal_client"></app-prospect-profile>
        </div>
        <div class="modal-content-section" *ngIf="selected_modal_client_loader">
            <app-loader [loading_text]="'Loading Lead Profile'"></app-loader>
        </div>
    </div>
</ng-template>

<ng-container *ngIf="show_user_profile">
    <ng-container *ngIf="user_profile_data.source_type_id != 1 ">
        <app-lead-profile [data]="user_profile_data" (profileClosed)="profileClosed($event)"></app-lead-profile>
      </ng-container>
      <ng-container *ngIf="user_profile_data.source_type_id == 1 ">
        <app-bank-customer-profile [data]="user_profile_data" (profileClosed)="profileClosed($event)"></app-bank-customer-profile>
      </ng-container>
  </ng-container>
